<template>
  <div class="farm-window farm-card">
    <div class="stat-bars">
      <p><b>Date</b></p>
      <div class="option-buttons" style="grid-template-columns: 4fr 3fr 1fr 1fr 1fr">
        <p style="text-align: left;">{{ util().currentDate(farm.state.time) }}</p>
        <TextButton class="farm-button" style="margin-right: 5px; border-right: 1px solid black;"
                    @click="farm.toggleUpdating(); $forceUpdate()">
          <p><b>
            <span v-if="!farm.updateIsRunning"> Start Time </span>
            <span v-else> Pause Time </span>
          </b></p>
        </TextButton>
        <TextButton class="farm-button" @click="farm.state.timeDilationFactor = 0.5" :class="{'disabled-button': farm.state.timeDilationFactor === 0.5}">
          <p><b>
            1x
          </b></p>
        </TextButton>
        <TextButton class="farm-button" @click="farm.state.timeDilationFactor = 1" :class="{'disabled-button': farm.state.timeDilationFactor === 1}">
          <p><b>
            2x
          </b></p>
        </TextButton>
        <TextButton class="farm-button" @click="farm.state.timeDilationFactor = 2" :class="{'disabled-button': farm.state.timeDilationFactor === 2}">
          <p><b>
            4x
          </b></p>
        </TextButton>
      </div>

      <p><b>News</b></p>
      <div class="option-buttons">
        <div class="farm-list">
          <p v-if="farm.state.eventManager.events.length > 0" >{{ farm.state.eventManager.events[0].text }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    }
  }
})
export default class FarmStatusCard extends Vue {
  farm!: Farm
}
</script>

<style scoped lang="scss">
  .farm-card {
    text-align: left;
    width: 1fr;
  }

  .farm-list {
    overflow-y: auto;
  }

  .stat-bars {
    display: grid;
    grid-template-columns: 60px 1fr;
    grid-template-rows: 30px 65px;
    grid-gap: 0px;

    .value-meter {
      margin-top: auto;
      margin-bottom: auto;
      height: 80%;
    }

    p {
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  .option-buttons {
    display: grid;

    p {
      text-align: center;
    }

    .text-button {
      display: table;
      border: $component-border-style;
      border-right: 0;
      height: 80%;
      margin-top: auto;
      margin-bottom: auto;

      &:last-child {
        border: $component-border-style;
      }

      p {
        display: table-cell;
        vertical-align: middle;
      }
    }
  }

</style>
